export default {
  on: true,
  cache: true,
  auth: true,
  intercept: false,

  title: '中小学销售管理详情',
  dynamicParam: '/:mode/:id?',
} as TCommon.RouteConfig
